import { ItineraryPoint } from 'data/models/ItineraryPoint';
import { RecurringBatch as ServerRecurringBatch } from 'server/models/RecurringBatch';

export { RecurringBatchOptions, RecurringBatchData } from 'server/models/RecurringBatch';

export class RecurringBatch extends ServerRecurringBatch {
    ReservationPoints() {
        return this.PortCalls()
            .map(pc => pc.Itinerary().filter(pt => pt.BerthReservation() !== null))
            .reduce((pts, nextPts) => pts.concat(nextPts), [] as ItineraryPoint[])
            .slice()
            .sort(ItineraryPoint.EffectiveOrder);
    }

    Reservations() {
        return this.ReservationPoints()
            .filter(pt => pt.BerthReservation() !== null)
            .map(pt => pt.BerthReservation()!);
    }

    FirstReservationPoint() {
        return this.ReservationPoints().length > 0 ? this.ReservationPoints()[0] : null;
    }

    LastReservationPoint() {
        return this.ReservationPoints().length > 0 ? this.ReservationPoints()[this.ReservationPoints().length - 1] : null;
    }

    FirstReservation() {
        return this.FirstReservationPoint() && this.FirstReservationPoint()!.BerthReservation();
    }

    LastReservation() {
        return this.LastReservationPoint() && this.LastReservationPoint()!.BerthReservation();
    }

    FirstPortCall() {
        return this.FirstReservationPoint() && this.FirstReservationPoint()!.PortCall();
    }

    LastPortCall() {
        return this.LastReservationPoint() && this.LastReservationPoint()!.PortCall();
    }
}


// WEBPACK FOOTER //
// ./data/models/RecurringBatch.ts